import { Role } from '@/Enums/Users/Role.enum';
import { DEFAULT_USER } from '@/constants/userManagement/userForm';
import { isOrgAdminRole, isSuperAdminRole } from '@/helpers/roles';

export const getNewUserDefaultValue = (meRole: Role, meWhitelabel: number) => {
  if (isSuperAdminRole(meRole)) {
    return DEFAULT_USER;
  }
  if (isOrgAdminRole(meRole)) {
    return {
      ...DEFAULT_USER,
      organization: {
        id: meWhitelabel,
      },
    };
  }
  // WL Admin
  return {
    ...DEFAULT_USER,
    whitelabel: {
      id: meWhitelabel,
    },
  };
};
